// extracted by mini-css-extract-plugin
export default {"button":"ButtonX_button__gIc1t","red":"ButtonX_red__uZ+tv","white":"ButtonX_white__KIVft"};